import { Component, Inject, Injector, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from '../app-component-base';
import { CommonDataModel } from '../common-data-model';
import { FreightShopperCarrierListComponent } from '../freight-shopper-carrier-list/freight-shopper-carrier-list.component';
import { CommonMethod } from 'src/app-core/methods/common-methods';

@Component({
    selector: 'app-orders-freight-shopper-form',
    templateUrl: './orders-freight-shopper-form.component.html',
    styleUrls: ['./orders-freight-shopper-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OrdersFreightShopperFormComponent extends AppComponentBase implements OnInit {

    @ViewChild('gridRecentQuote', { static: true }) private gridRecentQuote: GridComponent;
    @ViewChild('FreightShopperCarrierListComponent', { static: false }) FreightShopperCarrierListComponent: FreightShopperCarrierListComponent;
    @ViewChild(TooltipDirective, { static: true }) public tooltipDir: TooltipDirective;
    ordersData: any;
    isFormLoading = false;
    carriersList = [];
    accessorialsList = [];
    selectedCarries = [];
    selectedAccessorials = [];
    isYrcChecked = false;
    commonConstants: typeof CommonConstants = CommonConstants;
    statusValue = 'true';
    recentQuotes: any;
    ratesGrid: any[];
    expandedDetailKeys: any[] = [];
    orderPreviewData: any;
    isFV: boolean;
    isGetQuote: boolean;
    isOriginInitialLoad: boolean;
    isDestinationInitialLoad: boolean;
    isReQuote: boolean;
    commonDataModel = new CommonDataModel();
    getQuoteRequest = this.commonDataModel.getQuoteRequestModel;
    classList = this.commonDataModel.getCommonCarrierClass;
    originLocationTypePreviewData = _.cloneDeep(this.commonDataModel.dropdownDatModel);
    destinationLocationTypePreviewData = _.cloneDeep(this.commonDataModel.dropdownDatModel);
    ratesGridSort: SortDescriptor[];
    isChoose = false;
    userProfile: any;
    isFVPermission: boolean;
    minDate = moment().format();
    shipFromStartTime: any;
    shipFromEndTime: any;
    shipToStartTime: any;
    shipToEndTime: any;
    minOperationEndTime: any;
    locationList: any;
    originAccessorials: any;
    limitedAccessResidentialOriginList: any;
    limitedAccessResidentialDestList: any;
    businessDestList: any;
    locationDefaultItem: any;
    defaultStartTime: any = moment().set({ hour: 8, minute: 0, second: 0, millisecond: 0 }).format();
    defaultEndTime: any = moment().set({ hour: 17, minute: 0, second: 0, millisecond: 0 }).format();
    previousPickupDate: any;

    constructor(
        injector: Injector,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<OrdersFreightShopperFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        private toastr: ToastrService) {
        super(injector);
        this.isFVPermission = this.commonService.permissionCheckByName('FreightView');
    }

    ngOnInit() {
        this.isFV = this.commonService.getTenentIsFreightViewIntegrated();
        if (this.isFV === false) {
            this.statusValue = 'true';
        }
        this.isOriginInitialLoad = true;
        this.isDestinationInitialLoad = true;
        this.isGetQuote = false;
        this.isReQuote = false;
        this.ordersData = this.data;
        this.getLocationList();
        this.getCarriersList();
        this.getAccessorials();
        this.getInitialDataForFreightShopper();
        this.expandRows();
    }

    sortChange(sort: SortDescriptor[]): void {
        this.ratesGridSort = sort;
        this.loadProducts();
    }

    loadProducts(): void {
        this.ratesGrid = orderBy(this.ratesGrid, this.ratesGridSort);
    }

    onRefreshGridData(): void {
        this.kendogridHelper.sort = [{ dir: 'asc', field: 'createdDate' }];
        if (this.statusValue === 'false') {
            this.gridRecentQuote.dataStateChange.emit({
                skip: 0,
                take: this.kendogridHelper.defaultRecordsCountPerPage,
                filter: undefined,
                group: undefined,
                sort: this.kendogridHelper.sort,
            });
        }
    }

    getGridRecords(event: DataStateChangeEvent): void {
        if (event) {
            this.kendogridHelper.dataStateChangeEvent(event);
        }
        this.kendogridHelper.showLoadingIndicator();
        this.getRecentQuotes(event);
    }

    onCellClickHandler(event: any) {
        if (event.column.field === this.commonConstants.freightShopperConstants.shippingCost) {
            event.sender.expandRow(event.rowIndex);
            this.ratesGrid[event.rowIndex].isShippingCostExpand = !this.ratesGrid[event.rowIndex].isShippingCostExpand;
        }
    }

    onDetailRowCellClick(event: any) {
        if (event.column.field === this.commonConstants.freightShopperConstants.shippingCost) {
            this.toggleRowExpansion(event.dataItem.id);
        }
    }

    expandDetailsBy = (dataItem: any): any => {
        return dataItem.id;
    }

    toggleRowExpansion(id: number) {
        const idIndex: number = this.expandedDetailKeys.findIndex((item) => item === id);
        if (idIndex < 0) {
            this.expandedDetailKeys = [...this.expandedDetailKeys, id];
            return false;
        } else {
            this.expandedDetailKeys.splice(idIndex, 1);
            this.expandedDetailKeys = [...this.expandedDetailKeys];
            return true;
        }
    }

    onShowArrowIcon(id: number) {
        const idIndex: number = this.expandedDetailKeys.findIndex((item) => item === id);
        if (idIndex < 0) {
            return false;
        }
        return true;
    }

    getLocationList() {
        this.isFormLoading = true;
        this.commonService.getLocationType().subscribe((response: any) => {
            if (response.isSuccess) {
                this.locationList = [...response.data];
                if (this.locationList.length > 0) {
                    this.locationDefaultItem = this.locationList[0];
                    this.originLocationTypePreviewData = this.locationDefaultItem;
                    this.destinationLocationTypePreviewData = this.locationDefaultItem;
                    this.locationList.shift();
                }
            }
        });
    }

    getCarriersList() {
        const queryString = `CarrierId=0`;
        this.commonService.getCarriersList(queryString).subscribe((response: any) => {
            if (response.isSuccess) {
                this.carriersList = response.data;
                this.carriersList.map(item => {
                    item.isChecked = false;
                });
                this.carriersList = this.carriersList.filter(item => item.isApiIntegration);
            }
        });
    }

    getAccessorials() {
        this.isFormLoading = true;
        this.commonService.getAccessorials().subscribe((response: any) => {
            if (response.isSuccess) {
                this.accessorialsList = response.data;
                this.limitedAccessResidentialOriginList = this.accessorialsList.filter(obj => obj.name == "Liftgate required for pickup?" || obj.name == "Inside Pickup Required?");
                this.limitedAccessResidentialDestList = this.accessorialsList.filter(obj => obj.name == "Call/notify before delivery" || obj.name == "Delivery appointment required" || obj.name == "Inside Delivery Required?" || obj.name == "Liftgate required for delivery?");
                this.businessDestList = this.accessorialsList.filter(obj => obj.name == "Call/notify before delivery" || obj.name == "Delivery appointment required" );
                this.accessorialsList.map(item => {
                    item.isChecked = false;
                });
                this.isFormLoading = false;
            }
        });
    }

    onSaveFreightShopper() {
        const sendingData = {
            confirmResult: true,
            selectedCarries: this.selectedCarries,
            selectedAccessorials: this.selectedAccessorials,
            updatedCarrierCostList: this.FreightShopperCarrierListComponent.gridItems
        };
        let totalWeight = 0;
        this.getQuoteRequest.items = [];
        this.ordersData.carrierCostList.data.map(item => {
            this.getQuoteRequest.items.push({
                quantity: item.quantity,
                nmfcClass: item.class,
                packageType: item.packageType,
                length: Math.ceil(item.outerLength),
                width: Math.ceil(item.outerWidth),
                height: Math.ceil(item.outerHeight),
                weight: Math.ceil(item.extWeight),
                description: item.description ? item.description : item.containerName,
                nmfc: item.nmfc
            });
            totalWeight += item.extWeight;
        });
        let isClassSelected = false;
        let isPkgSelected = false;
        this.getQuoteRequest.items.map(val => {
            if (val.nmfcClass === null || val.nmfcClass === '') {
                isClassSelected = true;
            } else if (val.packageType === null || val.packageType === '') {
                isPkgSelected = true;
            }
        });
        if (this.isFV && this.isFVPermission) {
            if (this.isChoose) {
                return;
            }
            this.isGetQuote = true;
            if (this.ordersData.isShipperAddress) {
                this.getQuoteRequest.shipper.city = this.orderPreviewData.shipper.city;
                this.getQuoteRequest.shipper.state = this.orderPreviewData.shipper.provinceName;
                this.getQuoteRequest.shipper.zipcode = this.orderPreviewData.shipper.zipCode;
            } else {
                this.getQuoteRequest.shipper.city = this.commonService.getTCity();
                this.getQuoteRequest.shipper.state = this.commonService.getTState();
                this.getQuoteRequest.shipper.zipcode = this.commonService.getTZipcode();
            }
            this.getQuoteRequest.shipper.readyTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipFromReadyTime));
            this.getQuoteRequest.shipper.closeTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipFromCloseTime));
            this.getQuoteRequest.consignee.readyTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipToOpenTime));
            this.getQuoteRequest.consignee.closeTime = this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipToCloseTime));
            this.getQuoteRequest.consignee.city = this.orderPreviewData.consignee.city;
            this.getQuoteRequest.consignee.state = this.orderPreviewData.consignee.provinceName;
            this.getQuoteRequest.consignee.zipcode = this.orderPreviewData.consignee.zipCode;
            this.getQuoteRequest.serviceClass = 'STD';
            this.getQuoteRequest.pickupDate = moment(this.orderPreviewData.currentQuote.pickupDate).utcOffset(0, true).format();
            this.getQuoteRequest.deliveryDate = this.commonService.setTomorrowDate();
            this.getQuoteRequest.totalWeight = Math.ceil(totalWeight);
            this.getQuoteRequest.itemCount = this.getQuoteRequest.items.length;
            this.getQuoteRequest.accessorials = this.selectedAccessorials;
            this.getQuoteRequest.destinationLocationType = this.destinationLocationTypePreviewData;
            this.getQuoteRequest.originLocationType = this.originLocationTypePreviewData;
            if (isClassSelected) {
                this.toastr.warning(this.commonConstants.freightShopperConstants.pleaseSelectClassType);
            } else if (isPkgSelected) {
                this.toastr.warning(this.commonConstants.freightShopperConstants.pleaseSelectPkgType);
            } else {
                this.getFreightViewRating(this.getQuoteRequest);
            }
        } else {
            if (isClassSelected) {
                this.toastr.warning(this.commonConstants.freightShopperConstants.pleaseSelectClassType);
            } else if (isPkgSelected) {
                this.toastr.warning(this.commonConstants.freightShopperConstants.pleaseSelectPkgType);
            } else {
                this.dialogRef.close(sendingData);
            }
        }
    }

    getFreightViewRating(data) {
        this.isFormLoading = true;
        this.commonService.freightViewRating(data)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe((response: any) => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.ratesGrid = response.data;
                    this.isReQuote = true;
                } else {
                    this.toastr.error(response.errors);
                }
            });
    }

    onChangeCarrier() {
        this.selectedCarries = this.carriersList.filter(carrier => carrier.isChecked);
        this.yrcValidation();
    }

    onChangeAccessorial() {
        this.selectedAccessorials = this.accessorialsList.filter(accessorial => accessorial.isChecked).map(item => {
            return {
                yrcCode: item.yrcCode,
                estesCode: item.estesCode,
                fedexCode: item.fedexCode,
                accessorialId: item.id,
                accessorialName: item.name,
                originLocationTypeId: this.originLocationTypePreviewData.id,
                destinationLocationTypeId: this.destinationLocationTypePreviewData.id
            };
        });
    }

    yrcValidation() {
        const disabledRowIndex = _.findIndex(this.selectedCarries, ['carrierName', this.commonConstants.yrc]);
        if (disabledRowIndex >= 0) {
            this.isYrcChecked = true;
        } else {
            this.isYrcChecked = false;
            const custIndex = _.findIndex(this.selectedAccessorials, ['yrcCode', this.commonConstants.cust]);
            if (custIndex >= 0) {
                const mainCustIndex = _.findIndex(this.accessorialsList, ['yrcCode', this.commonConstants.cust]);
                this.accessorialsList[mainCustIndex].isChecked = false;
                this.onChangeAccessorial();
            }
        }
    }

    onClose(): void {
        this.dialogRef.close(false);
    }

    onToggleChange(value?: string) {
        this.statusValue = value;
        this.onRefreshGridData();
    }

    public showDetails(): boolean {
        return true;
    }

    getInitialDataForFreightShopper() {
        const payload = {
            id: this.ordersData.orderId,
            isShipper: this.ordersData.isShipperAddress,
            isConsignee: this.ordersData.isConsigneeAddress
        };
        this.commonService.getDataForFreightShopper(payload).subscribe((response: any) => {
            if (response.isSuccess) {
                this.orderPreviewData = response.data;
                this.isReQuote = this.orderPreviewData.isReQuote;
                if (response.data.currentQuote) {
                    this.getQuoteRequest.currentQuote.id = response.data.currentQuote.id;
                    this.orderPreviewData.currentQuote.shipFromReadyTime = response.data.currentQuote ? response.data.currentQuote.shipFromReadyTime ? moment(response.data.currentQuote.shipFromReadyTime, ['h:m a', 'H:m']).format() : this.defaultStartTime : this.defaultStartTime;
                    this.orderPreviewData.currentQuote.shipFromCloseTime = response.data.currentQuote ? response.data.currentQuote.shipFromCloseTime ? moment(response.data.currentQuote.shipFromCloseTime, ['h:m a', 'H:m']).format() : this.defaultEndTime : this.defaultEndTime;
                    this.orderPreviewData.currentQuote.shipToOpenTime = response.data.currentQuote ? response.data.currentQuote.shipToOpenTime ? moment(response.data.currentQuote.shipToOpenTime, ['h:m a', 'H:m']).format() : this.defaultStartTime : this.defaultStartTime;
                    this.orderPreviewData.currentQuote.shipToCloseTime = response.data.currentQuote ? response.data.currentQuote.shipToCloseTime ? moment(response.data.currentQuote.shipToCloseTime, ['h:m a', 'H:m']).format() : this.defaultEndTime : this.defaultEndTime;
                    this.previousPickupDate = moment(response.data.currentQuote.pickupDate).format('MM-DD-YYYY');
                    this.orderPreviewData.currentQuote.pickupDate = new Date();
                } else {
                    this.orderPreviewData.currentQuote = {};
                    this.getQuoteRequest.currentQuote.id = null;
                    this.orderPreviewData.currentQuote.pickupDate = new Date();
                    this.orderPreviewData.currentQuote.shipFromReadyTime = this.defaultStartTime;
                    this.orderPreviewData.currentQuote.shipFromCloseTime = this.defaultEndTime;
                    this.orderPreviewData.currentQuote.shipToOpenTime = this.defaultStartTime;
                    this.orderPreviewData.currentQuote.shipToCloseTime = this.defaultEndTime;
                }
            }
        });
    }

    getRecentQuotes(event: any) {
        const searchQuery = `&orderId=${this.orderPreviewData.id}`;
        this.commonService.getRecentQuotesByOrderId(event, searchQuery).subscribe((response: any) => {
            if (response.isSuccess) {
                this.recentQuotes = response;
                this.kendogridHelper.setGridData(this.recentQuotes.data);
                this.kendogridHelper.hideLoadingIndicator();
            }
        });
    }

    getTotal(val: any) {
        let totalAmount = 0;
        val.map(item => {
            totalAmount += item.amount;
        });
        return totalAmount;
    }

    onChoose(val: any) {
        this.isFormLoading = true;
        this.isChoose = true;
        const containerDetails = [];
        const pickupDate = new Date(this.getQuoteRequest.pickupDate);
        const transitDays = (val.transitDays != null && val.transitDays != '') ? val.transitDays : 0;
        const data = {
            carrierId: val.carrierDetailsId,
            carrierMessage: null,
            carrierName: val.carrier,
            deliveryDate: moment(pickupDate).add(transitDays, 'day').format(),
            serviceTypeName: val.serviceDescription,
            shippingCost: val.shippingCost,
            transitDays: val.transitDays
        };
        this.ordersData.carrierCostList.data.map(values => {
            containerDetails.push({
                freightClass: values.class,
                packageType: values.packageType,
                containerName: values.containerName,
                itemContainerId: values.itemContainerId,
                quantity: values.quantity,
                itemsDH: Number(values.outerHeight),
                itemsDL: Number(values.outerLength),
                itemsDW: Number(values.outerWidth),
                totalWeight: Number(values.extWeight),
                unitWeight: Number(values.unitWeight)
            });
        });
        const payload = {
            quoteId: val.quoteId,
            rateId: val.id,
            refNumber: val.refNumber,
            orderId: this.ordersData.orderId,
            carrierId: val.carrierDetailsId,
            carrierName: val.carrier,
            transitDays: val.transitDays,
            Mode: val.mode,
            cost: val.shippingCost,
            Charges: val.charges,
            carrierUrl: val.carrierUrl ? val.carrierUrl : '',
            serviceName: val.serviceType,
            serviceDescription: val.serviceDescription,
            pickupDate: moment(this.orderPreviewData.currentQuote.pickupDate).utcOffset(0, true).format(),
            shipFromReadyTime: this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipFromReadyTime)),
            shipFromCloseTime: this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipFromCloseTime)),
            shipToOpenTime: this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipToOpenTime)),
            shipToCloseTime: this.convertTimeToTimeString(this.commonService.convertedDateTimeFormat(this.orderPreviewData.currentQuote.shipToCloseTime)),
            containerDetails
        };

        this.commonService.saveRecentQuote(payload).subscribe((response: any) => {
            this.isFormLoading = false;
            if (response.isSuccess) {
                this.dialogRef.close({ data, from: 'ratesGrid', accessorials: this.selectedAccessorials });
            }
        });

    }

    formatDimensions(value: number): number {
        return this.commonMethod.convertDecimalToNextWholeNumber(value);
    }

    expandRows() {
        this.commonMethod.expandRows(this.gridRecentQuote);
    }

    onShowTooltip(e: any): void {
        if (e.target.offsetWidth < e.target.scrollWidth) {
            this.tooltipDir.toggle({ nativeElement: e.target });
        } else {
            this.tooltipDir.hide();
        }
    }

    onChangeDate(event: any) {
        // to do
    }

    onStartTimeChange(data: any) {
        // this.setMinTimeForEndTime();
    }

    convertTimeToTimeString(time: any) {
        const exactTime = new Date(time);
        const hours = exactTime.getHours();
        const minutes = this.commonService.addZeroToMinutes(exactTime.getMinutes());
        const timeString = this.commonService.getExactHours(hours, minutes);
        return timeString;
    }

    disableWeekends = (d: Date): boolean => {
        const day = d.getDay();
        return day !== 0 && day !== 6;
    }

    onDisabledAccessorials(): void {
        const limitedAccessIndex = _.findIndex(this.accessorialsList, ['name', 'Limited Access']);
        const residentialDeliveryIndex = _.findIndex(this.accessorialsList, ['name', 'Residential Delivery']);
        const residentialPickupIndex = _.findIndex(this.accessorialsList, ['name', 'Residential Pickup']);
        if (this.accessorialsList[residentialDeliveryIndex].isChecked && this.accessorialsList[residentialPickupIndex].isChecked) {
            this.accessorialsList[limitedAccessIndex].isActive = false;
        } else {
            this.accessorialsList[limitedAccessIndex].isActive = true;
        }

        if (this.accessorialsList[residentialPickupIndex].isChecked && this.accessorialsList[limitedAccessIndex].isChecked) {
            this.accessorialsList[residentialDeliveryIndex].isActive = false;
        } else {
            this.accessorialsList[residentialDeliveryIndex].isActive = true;
        }

        if (this.accessorialsList[limitedAccessIndex].isChecked && this.accessorialsList[residentialDeliveryIndex].isChecked) {
            this.accessorialsList[residentialPickupIndex].isActive = false;
        } else {
            this.accessorialsList[residentialPickupIndex].isActive = true;
        }
        this.onChangeAccessorial();
    }

    onChangeLocationType(data: any, locationType: any) {
        if (locationType === 'Origin') {
            this.clearAccessorialsSelection(data, locationType);
            this.originLocationTypePreviewData = _.cloneDeep(data);
        } else if (locationType === 'Destination') {
            this.clearAccessorialsSelection(data, locationType);
            this.destinationLocationTypePreviewData = _.cloneDeep(data);
        }
    }

    clearAccessorialsSelection(data: any, locationType: any): void {
        const limitedAccessIndex = _.findIndex(this.accessorialsList, ['name', 'Limited Access']);
        const residentialDeliveryIndex = _.findIndex(this.accessorialsList, ['name', 'Residential Delivery']);
        const residentialPickupIndex = _.findIndex(this.accessorialsList, ['name', 'Residential Pickup']);
        if (locationType === 'Origin' && data && data.id > 0 && data.id !== this.originLocationTypePreviewData.id) {
            this.limitedAccessResidentialOriginList.map(s => s.isChecked = false);
        }
        if (locationType === 'Destination' && data && data.id > 0 && data.id !== this.originLocationTypePreviewData.id) {
            this.limitedAccessResidentialDestList.map(s => s.isChecked = false);
            this.businessDestList.map(s => s.isChecked = false);
        }
        if (this.accessorialsList[residentialDeliveryIndex].isChecked && this.accessorialsList[residentialPickupIndex].isChecked) {
            this.accessorialsList[limitedAccessIndex].isActive = false;
        } else {
            this.accessorialsList[limitedAccessIndex].isActive = true;
        }

        if (this.accessorialsList[residentialPickupIndex].isChecked && this.accessorialsList[limitedAccessIndex].isChecked) {
            this.accessorialsList[residentialDeliveryIndex].isActive = false;
        } else {
            this.accessorialsList[residentialDeliveryIndex].isActive = true;
        }

        if (this.accessorialsList[limitedAccessIndex].isChecked && this.accessorialsList[residentialDeliveryIndex].isChecked) {
            this.accessorialsList[residentialPickupIndex].isActive = false;
        } else {
            this.accessorialsList[residentialPickupIndex].isActive = true;
        }
        this.onChangeAccessorial();
    }
}
